import { omitBy } from 'lodash-es';
import { isNumber } from './is';

interface EnumItem {
  value: any;
  label: any;
}

// 枚举转数组
export function mapEnumToOptions(_enum: { [x: string]: any }) {
  const options: EnumItem[] = [];
  const reg = /^\d*$/;
  for (const member in _enum) {
    if (!isNumber(member)) {
      options.push({
        value: reg.test(member) ? Number(member) : member,
        label: _enum[member],
      });
    }
  }
  return options;
}

// 过滤对象中键值为undefined null 或者空字符串的键
export function omitByValues(obj: any, values = ['', undefined]) {
  return omitBy(obj, (item) => {
    return values.includes(item);
  });
}
// 防抖
export function debounce<T extends (...args: any[]) => any>(fn: T, delay: number = 200): T {
  let timeId: any = null;
  return ((...args: any[]) => {
    if (timeId) {
      clearTimeout(timeId);
    }
    timeId = setTimeout(() => {
      timeId = null;
      fn(...args);
    }, delay);
  }) as T;
}
// 节流
export function throttle<T extends (...args: any[]) => any>(fn: T, delay: number = 500): T {
  // 定义上次触发时间
  let last = 0;
  return ((...args: any[]) => {
    const now = +Date.now();
    // console.log('call', now, last, delay, fn);
    if (now > last + delay) {
      last = now;
      fn(...args);
    }
  }) as T;
}

/** 是否是微信开发环境 */
export function isWxDevEnv() {
  return /wechatdevtools/i.test(navigator.userAgent);
}

/** 是否是微信授权url */
export function isWxAuthUrl() {
  const url = new URL(window.location.href);
  return url.searchParams.has('code') && url.searchParams.has('state');
}
